//#region ../schema-sql-parser/dist/parser/dataType/Databricks.js
var DatabricksTypes = [
	"ARRAY",
	"BIGINT",
	"BINARY",
	"BOOLEAN",
	"BYTE",
	"CHAR",
	"DATE",
	"DEC",
	"DECIMAL",
	"DOUBLE",
	"FLOAT",
	"GEOGRAPHY",
	"GEOMETRY",
	"INT",
	"INTEGER",
	"INTERVAL DAY TO HOUR",
	"INTERVAL DAY TO MINUTE",
	"INTERVAL DAY TO SECOND",
	"INTERVAL DAY",
	"INTERVAL HOUR TO MINUTE",
	"INTERVAL HOUR TO SECOND",
	"INTERVAL HOUR",
	"INTERVAL MINUTE TO SECOND",
	"INTERVAL MINUTE",
	"INTERVAL MONTH",
	"INTERVAL SECOND",
	"INTERVAL YEAR TO MONTH",
	"INTERVAL YEAR",
	"INTERVAL",
	"LONG",
	"MAP",
	"NUMERIC",
	"OBJECT",
	"REAL",
	"SHORT",
	"SMALLINT",
	"STRING",
	"STRUCT",
	"TIMESTAMP_LTZ",
	"TIMESTAMP_NTZ",
	"TIMESTAMP",
	"TINYINT",
	"VARCHAR",
	"VARIANT",
	"VOID"
];
//#endregion
export { DatabricksTypes };
